import CopyIcon from '@/common/assets/icons/copyIcon.svg?react';
import DownloadIcon from '@/common/assets/icons/DownloadIconWithoutBg.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { FileRoleType } from '@/common/types/ApiResponseTypes.type';
import CarIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/carIcon.svg';
import MotorIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/motorImage.svg';
import { getChassisPdfQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getChassisPdf/getChassisPdfQueryOptions';
import { getChassisPlaceQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getChassisPlace/getChassisPlaceQueryOptions';
import { getVehicleModelQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleModel/getVehicleModelQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, BoxProps, Flex, Stack } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
export default ({
  open,
  closeModal,
  fileRole,
}: MainModalProps & { nextStep: () => void; fileRole: FileRoleType }) => (
  <MainModal closeModal={closeModal} open={open}>
    <TakePhotoChassisGuideModal fileRole={fileRole} />
  </MainModal>
);

const TakePhotoChassisGuideModal = ({
  fileRole,
}: {
  fileRole: FileRoleType;
}) => {
  const { id, damagedId } = useParams();

  const { data: vehicleData, isSuccess } = useQuery(
    getVehicleModelQueryOptions({
      id: id!,
      damaged_id: damagedId!,
      participantRoleType: fileRole,
    }),
  );

  const { data: chassisData } = useQuery(
    getChassisPlaceQueryOptions({
      id: vehicleData?.vehicle_model?.id!,
      enabled:
        isSuccess &&
        !!vehicleData?.vehicle_model &&
        !!vehicleData?.vehicle_type,
    }),
  );
  const { data: chassisPdf } = useQuery(
    getChassisPdfQueryOptions({
      enabled:
        (!!chassisData && !chassisData.chassis_engraving) ||
        (isSuccess && vehicleData?.vehicle_model === null),
      vehicle_type: vehicleData?.vehicle_type?.name ?? '',
    }),
  );

  const downloadPdf = () => {
    const link = document.createElement('a');
    link.href = chassisPdf?.file!;
    link.setAttribute('download', 'chassis.pdf');
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const vehicleTargetPart =
    vehicleData?.vehicle_type?.name !== 'motorcycle'
      ? 'شماره شاسی'
      : 'شماره تنه';
  const defaultImage =
    vehicleData?.vehicle_type?.name !== 'motorcycle' ? CarIcon : MotorIcon;
  return (
    <Box>
      <TitleDescription>
        راهنمای عکس‌برداری از {vehicleTargetPart}
      </TitleDescription>

      <Typography
        textStyle="b2"
        color="black-1"
        mt="1.5rem"
        textAlign="justify"
      >
        کارشناس عزیز، فرآیند عکس‌برداری از ثبت {vehicleTargetPart} آغاز می‌شود،
        به منظور شناسایی موقعیت {vehicleTargetPart} وسیله‌نقلیه‌ی خود می‌توانید
        از راهنما استفاده کنید.
      </Typography>
      <Stack mb="7rem" mt="1.8rem">
        <Stack
          backgroundColor="white"
          boxShadow="cardShadow"
          borderRadius="8px"
          p="14px"
          gap="1rem"
        >
          <Box flex={1}>
            <img
              className={css({
                width: '100%',
                objectFit: 'cover',
                maxW: '200px',
                marginX: 'auto',
              })}
              src={chassisData?.image ?? defaultImage}
              alt=""
            />
            <Typography textStyle="b2" color="black-2" textAlign="center">
              {chassisData?.name}
            </Typography>
          </Box>
          <Stack
            flex={1}
            backgroundColor="#F6F6F8"
            borderRadius="10px"
            p="14px"
          >
            <Flex>
              <Bullet backgroundColor="black-5" />
              <Typography textStyle="b2" color="black-3">
                محل حک {vehicleTargetPart}
              </Typography>
            </Flex>
            <Typography textStyle="b2" color="black-1">
              {chassisData?.chassis_engraving ??
                `نامشخص (به راهنمای ${vehicleTargetPart} مراجعه کنید.)`}
            </Typography>
          </Stack>
        </Stack>

        {chassisPdf?.file ? (
          <Flex
            backgroundColor="white"
            boxShadow="cardShadow"
            borderRadius="8px"
            p="14px"
            alignItems="center"
            gap="0.5rem"
          >
            <CustomIcon backgroundColor={'purple-6'} width={42} height={42}>
              <CopyIcon />
            </CustomIcon>
            <Typography textStyle="b1" color="black-2">
              راهنمای شناسایی {vehicleTargetPart}
            </Typography>
            <Flex onClick={downloadPdf} alignItems="center" gap="0.2rem">
              <DownloadIcon stroke={token('colors.purple-2')} width={20} />
              <Typography textStyle="b1" color="purple-2">
                دانلود
              </Typography>
            </Flex>
          </Flex>
        ) : null}
      </Stack>
    </Box>
  );
};

const Bullet = ({
  backgroundColor = 'purple-2',
}: {
  backgroundColor?: BoxProps['backgroundColor'];
}) => {
  return (
    <Box
      flexShrink={0}
      backgroundColor={backgroundColor}
      className={css({
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        marginLeft: '10px',
        mt: '8px',
      })}
    />
  );
};
